// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /**
   * Represents non-fractional signed whole numeric values. Since the value may
   * exceed the size of a 32-bit integer, it's encoded as a string.
   */
  BigInt: { input: any; output: any };
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: any; output: any };
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any };
  /** Represents untyped JSON */
  JSON: { input: any; output: any };
  /** Range type */
  Range: { input: any[]; output: any[] };
};

export type Agency = Node & {
  __typename?: "Agency";
  /** AI-generated summary of reviews provided in the locale of the request */
  aiReviewSummary?: Maybe<AiReviewSummary>;
  awards: AwardConnection;
  claimed?: Maybe<Scalars["Boolean"]["output"]>;
  competitors?: Maybe<AgencyConnection>;
  /** The cover picture url of the agency. */
  coverPictureUrl?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  externalId?: Maybe<Scalars["String"]["output"]>;
  foundedAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  id: Scalars["ID"]["output"];
  languages?: Maybe<Array<Scalars["String"]["output"]>>;
  linkedinId?: Maybe<Scalars["String"]["output"]>;
  /** The agency is visible publicly */
  live: Scalars["Boolean"]["output"];
  locale?: Maybe<Scalars["String"]["output"]>;
  logoUrl?: Maybe<Scalars["String"]["output"]>;
  mainOffice?: Maybe<Office>;
  name: Scalars["String"]["output"];
  offices: OfficeConnection;
  paidMember?: Maybe<Scalars["Boolean"]["output"]>;
  prospectAreas: ProspectAreaConnection;
  remotely?: Maybe<Scalars["Boolean"]["output"]>;
  reviews: ReviewConnection;
  sectors: SectorConnection;
  services: ServiceConnection;
  slug?: Maybe<Scalars["String"]["output"]>;
  socialProfiles?: Maybe<SocialProfiles>;
  /** @deprecated use paid_member instead */
  sponsored?: Maybe<Scalars["Boolean"]["output"]>;
  story?: Maybe<Scalars["String"]["output"]>;
  tagline?: Maybe<Scalars["String"]["output"]>;
  /** The team picture url of the agency. */
  teamPictureUrl?: Maybe<Scalars["String"]["output"]>;
  teamSize?: Maybe<Scalars["Int"]["output"]>;
  trustedPartner?: Maybe<Scalars["Boolean"]["output"]>;
  turnover?: Maybe<Scalars["BigInt"]["output"]>;
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  uuid: Scalars["String"]["output"];
  /** @deprecated use claimed instead */
  verified?: Maybe<Scalars["Boolean"]["output"]>;
  website?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated use website instead */
  websiteUrl?: Maybe<Scalars["String"]["output"]>;
  wonOpportunitiesCount: Scalars["Int"]["output"];
  works: WorkConnection;
};

export type AgencyAwardsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AgencyCompetitorsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AgencyOfficesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AgencyProspectAreasArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AgencyReviewsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filter?: InputMaybe<ReviewFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AgencySectorsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AgencyServicesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AgencyWorksArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The connection type for Agency. */
export type AgencyConnection = {
  __typename?: "AgencyConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AgencyEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Agency>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

/** An edge in a connection. */
export type AgencyEdge = {
  __typename?: "AgencyEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge. */
  node?: Maybe<Agency>;
};

/** AI-generated summary of reviews provided in the locale of the request */
export type AiReviewSummary = Node & {
  __typename?: "AiReviewSummary";
  /** ID of the object. */
  id: Scalars["ID"]["output"];
  /** Key points extracted from the reviews */
  keyPoints?: Maybe<Array<Scalars["String"]["output"]>>;
  /** Themes identified in the reviews */
  themes?: Maybe<Array<AiReviewSummaryTheme>>;
};

/** A theme identified in the AI reviews summary */
export type AiReviewSummaryTheme = Node & {
  __typename?: "AiReviewSummaryTheme";
  /** The description of the theme */
  description: Scalars["String"]["output"];
  /** ID of the object. */
  id: Scalars["ID"]["output"];
  /** The title of the theme */
  title: Scalars["String"]["output"];
};

export type Aspect = Node & {
  __typename?: "Aspect";
  /** Description of the aspect */
  description: Scalars["String"]["output"];
  /** Expertise that the service is linked to */
  expertise?: Maybe<Expertise>;
  id: Scalars["ID"]["output"];
  /** Position that is used to display the aspects in a specific order. */
  position?: Maybe<Scalars["Int"]["output"]>;
  /** Service that was provided by the agency */
  service?: Maybe<Service>;
  /** Work that the aspect is linked to */
  work: Work;
};

/** The connection type for Aspect. */
export type AspectConnection = {
  __typename?: "AspectConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AspectEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Aspect>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

/** An edge in a connection. */
export type AspectEdge = {
  __typename?: "AspectEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge. */
  node?: Maybe<Aspect>;
};

export type Award = Node & {
  __typename?: "Award";
  agency: Agency;
  category?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  position?: Maybe<Scalars["Int"]["output"]>;
  slug: Scalars["String"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  uuid: Scalars["String"]["output"];
  wonAt?: Maybe<Scalars["ISO8601Date"]["output"]>;
  work?: Maybe<Work>;
};

/** The connection type for Award. */
export type AwardConnection = {
  __typename?: "AwardConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AwardEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Award>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

/** An edge in a connection. */
export type AwardEdge = {
  __typename?: "AwardEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge. */
  node?: Maybe<Award>;
};

export type Company = Node & {
  __typename?: "Company";
  address?: Maybe<Scalars["String"]["output"]>;
  coordinates?: Maybe<Scalars["JSON"]["output"]>;
  country?: Maybe<Location>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  googlePlaceId?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  locality?: Maybe<Location>;
  marketSize?: Maybe<Scalars["String"]["output"]>;
  marketType?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  sector?: Maybe<Sector>;
  size?: Maybe<Scalars["Int"]["output"]>;
  turnover?: Maybe<Scalars["BigInt"]["output"]>;
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  website?: Maybe<Scalars["String"]["output"]>;
};

/** Autogenerated input type of CreateTopicMutation */
export type CreateTopicMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Stable identifier within the `type` namespace. Defaults to a random UUID when
   * omitted (the common case for curated `CUSTOM` topics). Pass the upstream id
   * when mirroring a non-custom source.
   */
  externalId?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * When set, the topic is promoted in the agency UX (in-app prompts such as 'a
   * new skill tag is available for this service') to drive adoption. Used to ramp
   * coverage on a topic before we build directory pages around it.
   */
  featuredAt?: InputMaybe<Scalars["ISO8601DateTime"]["input"]>;
  /** ID of the parent topic, if any. */
  parentTopicId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Translation entries (one per locale) for the new topic. */
  translations: Array<TopicTranslationInput>;
  /**
   * Topic category. Defaults to `CUSTOM` for curated topics created via the admin
   * UI. Pass another value (e.g. `LOCATION`, `LOCALE`) when seeding topics that
   * mirror an upstream source.
   */
  type?: InputMaybe<TopicCategory>;
};

/** Autogenerated return type of CreateTopicMutation. */
export type CreateTopicMutationPayload = Node & {
  __typename?: "CreateTopicMutationPayload";
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** ID of the object. */
  id: Scalars["ID"]["output"];
  topic: Topic;
};

/** Autogenerated input type of DeleteTopicMutation */
export type DeleteTopicMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** ID of the topic to delete. */
  topicId: Scalars["ID"]["input"];
};

/** Autogenerated return type of DeleteTopicMutation. */
export type DeleteTopicMutationPayload = Node & {
  __typename?: "DeleteTopicMutationPayload";
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** ID of the object. */
  id: Scalars["ID"]["output"];
  topic: Topic;
};

export type Domain = Node & {
  __typename?: "Domain";
  availableLocales: Array<Locale>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  host: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  iso31661?: Maybe<Scalars["String"]["output"]>;
  location?: Maybe<Location>;
  mainLocale?: Maybe<Locale>;
  robots?: Maybe<Scalars["String"]["output"]>;
  sitemapStaticPaths?: Maybe<Scalars["String"]["output"]>;
  sitemapStatics?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["ISO8601DateTime"]["output"];
};

export type Expertise = NamedTopic &
  Node & {
    __typename?: "Expertise";
    category?: Maybe<Scalars["String"]["output"]>;
    createdAt: Scalars["ISO8601DateTime"]["output"];
    id: Scalars["ID"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
    slug?: Maybe<Scalars["String"]["output"]>;
    updatedAt: Scalars["ISO8601DateTime"]["output"];
    uuid: Scalars["String"]["output"];
  };

export type Locale = NamedTopic &
  Node & {
    __typename?: "Locale";
    code: Scalars["String"]["output"];
    id: Scalars["ID"]["output"];
    main: Scalars["Boolean"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
    slug?: Maybe<Scalars["String"]["output"]>;
  };

export type Location = NamedTopic &
  Node & {
    __typename?: "Location";
    address?: Maybe<Scalars["String"]["output"]>;
    country?: Maybe<Location>;
    countryIso31661?: Maybe<Scalars["String"]["output"]>;
    createdAt: Scalars["ISO8601DateTime"]["output"];
    currency?: Maybe<Scalars["String"]["output"]>;
    famous?: Maybe<Scalars["Boolean"]["output"]>;
    frPrefix?: Maybe<Scalars["String"]["output"]>;
    geometry?: Maybe<Scalars["JSON"]["output"]>;
    googlePlaceId?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    iso31661?: Maybe<Scalars["String"]["output"]>;
    iso31662?: Maybe<Scalars["String"]["output"]>;
    level: Scalars["String"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
    simpleAddress?: Maybe<Scalars["String"]["output"]>;
    slug?: Maybe<Scalars["String"]["output"]>;
    superLocations: LocationConnection;
    updatedAt: Scalars["ISO8601DateTime"]["output"];
  };

export type LocationSuperLocationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The connection type for Location. */
export type LocationConnection = {
  __typename?: "LocationConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LocationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Location>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

/** An edge in a connection. */
export type LocationEdge = {
  __typename?: "LocationEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge. */
  node?: Maybe<Location>;
};

/** Autogenerated input type of MarkAsBotMutation */
export type MarkAsBotMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** The IP address to mark as bot (optional, defaults to request IP) */
  ip?: InputMaybe<Scalars["String"]["input"]>;
  /** The timestamp when the bot mark should be applied (optional, defaults to current time) */
  markTime?: InputMaybe<Scalars["ISO8601DateTime"]["input"]>;
};

/** Autogenerated return type of MarkAsBotMutation. */
export type MarkAsBotMutationPayload = Node & {
  __typename?: "MarkAsBotMutationPayload";
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** ID of the object. */
  id: Scalars["ID"]["output"];
  ip: Scalars["String"]["output"];
  markTime: Scalars["ISO8601DateTime"]["output"];
};

/** Autogenerated input type of MergeTopicsMutation */
export type MergeTopicsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /** ID of the topic that survives the merge. */
  keepTopicId: Scalars["ID"]["input"];
  /** ID of the topic that is merged into the kept topic and destroyed. */
  mergeTopicId: Scalars["ID"]["input"];
};

/** Autogenerated return type of MergeTopicsMutation. */
export type MergeTopicsMutationPayload = Node & {
  __typename?: "MergeTopicsMutationPayload";
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** ID of the object. */
  id: Scalars["ID"]["output"];
  topic: Topic;
};

export type Mutation = Node & {
  __typename?: "Mutation";
  /**
   * Create a curated topic with translations (term + synonyms) per locale,
   * optionally linked to a parent topic and optionally promoted in the agency UX
   * from a given timestamp (see `featuredAt`). The topic embedding is generated
   * asynchronously from the translations.
   */
  createTopic?: Maybe<CreateTopicMutationPayload>;
  /**
   * Delete a topic. All dependent rows are cleaned up: `topic_translations`
   * (cascade), `topics_pages` / `topics_agencies` / `topics_works` (delete_all),
   * child topics' `parent_topic_id` (set null), and any `domain.location_topic_id`
   * pointing at this topic (set null).
   */
  deleteTopic?: Maybe<DeleteTopicMutationPayload>;
  /** ID of the object. */
  id: Scalars["ID"]["output"];
  markAsBot?: Maybe<MarkAsBotMutationPayload>;
  /**
   * Merge two topics into one. All children records of the merged topic
   * (translations, topics_agencies, topics_works, topics_pages, child topics) are
   * reassociated to the kept topic, the merged topic is destroyed and the kept
   * topic embedding is regenerated.
   */
  mergeTopics?: Maybe<MergeTopicsMutationPayload>;
  /**
   * Update a curated topic's translations, parent topic, and/or featured
   * timestamp. Only the fields provided are changed; omitted fields are left
   * untouched. If translations are provided, the topic embedding is regenerated
   * asynchronously.
   */
  updateTopic?: Maybe<UpdateTopicMutationPayload>;
};

export type MutationCreateTopicArgs = {
  input: CreateTopicMutationInput;
};

export type MutationDeleteTopicArgs = {
  input: DeleteTopicMutationInput;
};

export type MutationMarkAsBotArgs = {
  input: MarkAsBotMutationInput;
};

export type MutationMergeTopicsArgs = {
  input: MergeTopicsMutationInput;
};

export type MutationUpdateTopicArgs = {
  input: UpdateTopicMutationInput;
};

export type NamedTopic = {
  id: Scalars["ID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  slug?: Maybe<Scalars["String"]["output"]>;
};

/** An object with an ID. */
export type Node = {
  /** ID of the object. */
  id: Scalars["ID"]["output"];
};

export type Office = Node & {
  __typename?: "Office";
  address?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  /** The latitude of the office location */
  latitude?: Maybe<Scalars["Float"]["output"]>;
  locality?: Maybe<Location>;
  /** The longitude of the office location */
  longitude?: Maybe<Scalars["Float"]["output"]>;
  position?: Maybe<Scalars["Int"]["output"]>;
};

/** The connection type for Office. */
export type OfficeConnection = {
  __typename?: "OfficeConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OfficeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Office>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

/** An edge in a connection. */
export type OfficeEdge = {
  __typename?: "OfficeEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge. */
  node?: Maybe<Office>;
};

/** pages agency order by enum */
export enum OrderDirection {
  /** ascendent */
  Asc = "ASC",
  /** descendent */
  Desc = "DESC",
}

export type Page = Node & {
  __typename?: "Page";
  baselineValue?: Maybe<Scalars["Float"]["output"]>;
  briefingOptions?: Maybe<Scalars["JSON"]["output"]>;
  canonicalPage?: Maybe<Page>;
  cluster?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  description?: Maybe<Scalars["JSON"]["output"]>;
  domain: Domain;
  faq?: Maybe<Scalars["JSON"]["output"]>;
  frontendType?: Maybe<Scalars["String"]["output"]>;
  httpStatus?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  indexable: Scalars["Boolean"]["output"];
  locale: Locale;
  metadata?: Maybe<Scalars["JSON"]["output"]>;
  obfuscateInternals: Scalars["Boolean"]["output"];
  pageOptions?: Maybe<Scalars["JSON"]["output"]>;
  pagesAgencies: PagesAgencyConnection;
  path: Scalars["String"]["output"];
  redirectionPage?: Maybe<Page>;
  strictTopics: TopicUnionConnection;
  title?: Maybe<Scalars["JSON"]["output"]>;
  topics: TopicUnionConnection;
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  url: Scalars["String"]["output"];
};

export type PagePagesAgenciesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filter?: InputMaybe<PagesAgencyFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  order?: InputMaybe<PagesAgencyOrder>;
};

export type PageStrictTopicsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type PageTopicsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The connection type for Page. */
export type PageConnection = {
  __typename?: "PageConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PageEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Page>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

/** An edge in a connection. */
export type PageEdge = {
  __typename?: "PageEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge. */
  node?: Maybe<Page>;
};

export type PageFilter = {
  host: Scalars["String"]["input"];
  locale: Scalars["ID"]["input"];
  /** usually a locale plus some locations, expertise, skill */
  topics?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: "PageInfo";
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars["String"]["output"]>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars["Boolean"]["output"];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars["Boolean"]["output"];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars["String"]["output"]>;
};

export type PagesAgency = Node & {
  __typename?: "PagesAgency";
  activated?: Maybe<Scalars["Boolean"]["output"]>;
  agency: Agency;
  agencyCardMetadata?: Maybe<Scalars["JSON"]["output"]>;
  budget?: Maybe<Scalars["Range"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  id: Scalars["ID"]["output"];
  obfuscated?: Maybe<Scalars["Boolean"]["output"]>;
  page: Page;
  position?: Maybe<Scalars["Int"]["output"]>;
  relevanceScore?: Maybe<Scalars["Float"]["output"]>;
  sameCountryAsPage?: Maybe<Scalars["Boolean"]["output"]>;
  section: PagesAgencySection;
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  worksCount?: Maybe<Scalars["Int"]["output"]>;
};

/** The connection type for PagesAgency. */
export type PagesAgencyConnection = {
  __typename?: "PagesAgencyConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PagesAgencyEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PagesAgency>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

/** An edge in a connection. */
export type PagesAgencyEdge = {
  __typename?: "PagesAgencyEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge. */
  node?: Maybe<PagesAgency>;
};

export type PagesAgencyFilter = {
  awardsCounts?: InputMaybe<Array<Scalars["Range"]["input"]>>;
  budgets?: InputMaybe<Array<Scalars["Range"]["input"]>>;
  ratings?: InputMaybe<Array<Scalars["Range"]["input"]>>;
  reviewsCounts?: InputMaybe<Array<Scalars["Range"]["input"]>>;
  sections?: InputMaybe<Array<PagesAgencySection>>;
  teamSizes?: InputMaybe<Array<Scalars["Range"]["input"]>>;
  topics?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  worksCounts?: InputMaybe<Array<Scalars["Range"]["input"]>>;
};

export type PagesAgencyOrder = {
  by?: PagesAgencyOrderBy;
  direction?: OrderDirection;
};

/** pages agency order by enum */
export enum PagesAgencyOrderBy {
  /** agency reviews score */
  AgenciesReviewsScore = "AGENCIES_REVIEWS_SCORE",
  /** agency size */
  AgenciesSize = "AGENCIES_SIZE",
  /** position */
  Position = "POSITION",
  /** section */
  Section = "SECTION",
  /** works count */
  WorksCount = "WORKS_COUNT",
}

/** Pages agency section enum */
export enum PagesAgencySection {
  /** manual */
  Manual = "MANUAL",
  /** organic */
  Organic = "ORGANIC",
  /** paid */
  Paid = "PAID",
}

export type ProspectArea = Node & {
  __typename?: "ProspectArea";
  /** The address */
  address?: Maybe<Scalars["String"]["output"]>;
  agency: Agency;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  geometry: Scalars["JSON"]["output"];
  id: Scalars["ID"]["output"];
  /** The sorting position between prospect areas */
  position?: Maybe<Scalars["Int"]["output"]>;
  /** The radius of the prospect area in kilometers */
  radiusKm?: Maybe<Scalars["Int"]["output"]>;
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  /** The unique identifier */
  uuid: Scalars["String"]["output"];
};

/** The connection type for ProspectArea. */
export type ProspectAreaConnection = {
  __typename?: "ProspectAreaConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProspectAreaEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProspectArea>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

/** An edge in a connection. */
export type ProspectAreaEdge = {
  __typename?: "ProspectAreaEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge. */
  node?: Maybe<ProspectArea>;
};

export type Query = Node & {
  __typename?: "Query";
  _service: _Service;
  agency: Agency;
  /**
   * Lexical autocomplete for taxonomy topics. Matches the search text against
   * per-locale topic translations using PostgreSQL trigram word-similarity -
   * supports partial-prefix typeahead like `reac` -> `React`. Filters to the
   * request locale and to the topic categories listed in `types`. For semantic
   * suggestions, see `suggestTopics`.
   */
  autocompleteTopics: TopicConnection;
  domain: Domain;
  /**
   * Topics promoted in the agency UX (featured), most recently featured first. Use
   * `since` to list or count (via `totalCount`) topics featured after a given
   * timestamp - e.g. a service's skillsInspectedAt - to surface 'new skills to
   * review' prompts. Replaces the legacy Andromeda recent-terms feed.
   */
  featuredTopics: TopicConnection;
  /** ID of the object. */
  id: Scalars["ID"]["output"];
  /** Fetches an object given its ID. */
  node?: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  page: Page;
  searchPages: PageConnection;
  searchTopics: SearchTopicConnection;
  /**
   * Semantic topic suggestions intended for clickable tag UIs. Embeds the search
   * text once via OpenAI and ranks topics by cosine distance against their
   * pre-computed embeddings (one embedding per topic, built from the concatenation
   * of all translations — locale-independent). Filters to the topic categories
   * listed in `types`. For typeahead/lexical matching, see `autocompleteTopics`.
   */
  suggestTopics: TopicConnection;
  work: Work;
};

export type QueryAgencyArgs = {
  slug: Scalars["String"]["input"];
};

export type QueryAutocompleteTopicsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  searchText: Scalars["String"]["input"];
  types?: InputMaybe<Array<TopicCategory>>;
};

export type QueryDomainArgs = {
  host: Scalars["String"]["input"];
};

export type QueryFeaturedTopicsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  since?: InputMaybe<Scalars["ISO8601DateTime"]["input"]>;
};

export type QueryNodeArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryNodesArgs = {
  ids: Array<Scalars["ID"]["input"]>;
};

export type QueryPageArgs = {
  host: Scalars["String"]["input"];
  locale: Scalars["String"]["input"];
  path: Scalars["String"]["input"];
};

export type QuerySearchPagesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filter: PageFilter;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QuerySearchTopicsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  pageFilter?: InputMaybe<PageFilter>;
  searchText: Scalars["String"]["input"];
  types: Array<TopicExternalType>;
};

export type QuerySuggestTopicsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  searchText: Scalars["String"]["input"];
  types?: InputMaybe<Array<TopicCategory>>;
};

export type QueryWorkArgs = {
  slug: Scalars["String"]["input"];
};

export type Review = Node & {
  __typename?: "Review";
  agency: Agency;
  companySize?: Maybe<Scalars["Range"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  descriptionCons?: Maybe<Scalars["String"]["output"]>;
  descriptionPros?: Maybe<Scalars["String"]["output"]>;
  descriptionSummary?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  isRecentlyRecommended: Scalars["Boolean"]["output"];
  locale?: Maybe<Scalars["String"]["output"]>;
  onBehalf?: Maybe<Scalars["Boolean"]["output"]>;
  rating?: Maybe<Scalars["Float"]["output"]>;
  ratingBudget?: Maybe<Scalars["Float"]["output"]>;
  ratingCollaboration?: Maybe<Scalars["Float"]["output"]>;
  ratingQuality?: Maybe<Scalars["Float"]["output"]>;
  ratingSchedule?: Maybe<Scalars["Float"]["output"]>;
  recommended?: Maybe<Scalars["Boolean"]["output"]>;
  reply?: Maybe<Scalars["String"]["output"]>;
  sector?: Maybe<Sector>;
  service?: Maybe<Service>;
  slug: Scalars["String"]["output"];
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  userCompanyName?: Maybe<Scalars["String"]["output"]>;
  userFullName?: Maybe<Scalars["String"]["output"]>;
  userJobTitle?: Maybe<Scalars["String"]["output"]>;
  userPictureUrl?: Maybe<Scalars["String"]["output"]>;
  uuid: Scalars["String"]["output"];
  /** When the review was verified */
  verifiedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
};

/** The connection type for Review. */
export type ReviewConnection = {
  __typename?: "ReviewConnection";
  averageRating?: Maybe<Scalars["Float"]["output"]>;
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ReviewEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Review>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** used to sort, prefering those with more reviews when same average */
  score?: Maybe<Scalars["Float"]["output"]>;
  totalCount: Scalars["Int"]["output"];
  totalRating?: Maybe<Scalars["Float"]["output"]>;
};

/** An edge in a connection. */
export type ReviewEdge = {
  __typename?: "ReviewEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge. */
  node?: Maybe<Review>;
};

export type ReviewFilter = {
  recommended?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** The connection type for TopicUnion. */
export type SearchTopicConnection = {
  __typename?: "SearchTopicConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SearchTopicEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<TopicUnion>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

/** An edge in a connection. */
export type SearchTopicEdge = {
  __typename?: "SearchTopicEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge. */
  node?: Maybe<TopicUnion>;
  page?: Maybe<Page>;
};

export type Sector = NamedTopic &
  Node & {
    __typename?: "Sector";
    id: Scalars["ID"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
    slug?: Maybe<Scalars["String"]["output"]>;
  };

/** The connection type for Sector. */
export type SectorConnection = {
  __typename?: "SectorConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SectorEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Sector>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

/** An edge in a connection. */
export type SectorEdge = {
  __typename?: "SectorEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge. */
  node?: Maybe<Sector>;
};

export type Service = Node & {
  __typename?: "Service";
  agency: Agency;
  budget?: Maybe<Scalars["Range"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  expertise: Expertise;
  id: Scalars["ID"]["output"];
  position?: Maybe<Scalars["Int"]["output"]>;
  reviews: ReviewConnection;
  skills: TopicConnection;
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  uuid: Scalars["String"]["output"];
  works: WorkConnection;
};

export type ServiceReviewsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ServiceSkillsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ServiceWorksArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The connection type for Service. */
export type ServiceConnection = {
  __typename?: "ServiceConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ServiceEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Service>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalBudget?: Maybe<Scalars["Range"]["output"]>;
  totalCount: Scalars["Int"]["output"];
};

/** An edge in a connection. */
export type ServiceEdge = {
  __typename?: "ServiceEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge. */
  node?: Maybe<Service>;
};

export type SocialProfiles = Node & {
  __typename?: "SocialProfiles";
  createdAt: Scalars["ISO8601DateTime"]["output"];
  /** Facebook profile URL */
  facebook?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  /** Instagram profile URL */
  instagram?: Maybe<Scalars["String"]["output"]>;
  /** LinkedIn profile URL */
  linkedin?: Maybe<Scalars["String"]["output"]>;
  /** Pinterest profile URL */
  pinterest?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  /** Vimeo profile URL */
  vimeo?: Maybe<Scalars["String"]["output"]>;
  /** X (Twitter) profile URL */
  x?: Maybe<Scalars["String"]["output"]>;
  /** YouTube channel URL */
  youtube?: Maybe<Scalars["String"]["output"]>;
};

/**
 * A taxonomy concept (skill, expertise, audience, industry, etc). Returned by
 * `autocompleteTopics`, `suggestTopics` and `searchTopics` for picker UIs. Carries
 * the text translation for the request locale via the `term` field.
 */
export type Topic = NamedTopic &
  Node & {
    __typename?: "Topic";
    /**
     * Raw database id of the topic. Cross-API contract: pass this value as `topicId`
     * in the core API's TermInput when attaching the topic to a service or work.
     */
    databaseId: Scalars["BigInt"]["output"];
    /** Whether this topic is curated as a famous one */
    famous: Scalars["Boolean"]["output"];
    /**
     * Timestamp at which the topic started being promoted in the agency UX (in-app
     * prompts inviting agencies to add it to relevant services). Null when the topic
     * is not featured.
     */
    featuredAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
    id: Scalars["ID"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
    /**
     * Cosine distance between this topic's embedding and the query embedding.
     * Populated only on results from `suggestTopics`; null otherwise.
     */
    neighborDistance?: Maybe<Scalars["Float"]["output"]>;
    /** Pages associated with this topic */
    pages: PageConnection;
    slug?: Maybe<Scalars["String"]["output"]>;
    /** Alternate texts matching the topic in the request locale */
    synonyms: Array<Scalars["String"]["output"]>;
    /** Topic text in the request locale */
    term?: Maybe<Scalars["String"]["output"]>;
    /** Topic category */
    type: TopicCategory;
  };

/**
 * A taxonomy concept (skill, expertise, audience, industry, etc). Returned by
 * `autocompleteTopics`, `suggestTopics` and `searchTopics` for picker UIs. Carries
 * the text translation for the request locale via the `term` field.
 */
export type TopicPagesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

/**
 * Topic external_type values, used as a filter input on autocomplete/suggest and
 * as the discriminator field on the Topic object.
 */
export enum TopicCategory {
  /** audience */
  Audience = "AUDIENCE",
  /** category */
  Category = "CATEGORY",
  /** certification */
  Certification = "CERTIFICATION",
  /** custom */
  Custom = "CUSTOM",
  /** expertise */
  Expertise = "EXPERTISE",
  /** feature */
  Feature = "FEATURE",
  /** framework */
  Framework = "FRAMEWORK",
  /** industry */
  Industry = "INDUSTRY",
  /** locale */
  Locale = "LOCALE",
  /** location */
  Location = "LOCATION",
  /** platform */
  Platform = "PLATFORM",
  /** skill */
  Skill = "SKILL",
  /** user_generated */
  UserGenerated = "USER_GENERATED",
}

/** The connection type for Topic. */
export type TopicConnection = {
  __typename?: "TopicConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TopicEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Topic>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

/** An edge in a connection. */
export type TopicEdge = {
  __typename?: "TopicEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge. */
  node?: Maybe<Topic>;
};

/** topic's external_type enum */
export enum TopicExternalType {
  /** audience */
  Audience = "AUDIENCE",
  /** category */
  Category = "CATEGORY",
  /** certification */
  Certification = "CERTIFICATION",
  /** custom */
  Custom = "CUSTOM",
  /** expertise */
  Expertise = "EXPERTISE",
  /** feature */
  Feature = "FEATURE",
  /** framework */
  Framework = "FRAMEWORK",
  /** industry */
  Industry = "INDUSTRY",
  /** locale */
  Locale = "LOCALE",
  /** location */
  Location = "LOCATION",
  /** platform */
  Platform = "PLATFORM",
  /** skill */
  Skill = "SKILL",
  /** user_generated */
  UserGenerated = "USER_GENERATED",
}

/** Per-locale text data for a topic */
export type TopicTranslationInput = {
  /** Locale code (e.g. en, fr, de) */
  locale: Scalars["String"]["input"];
  /** Alternate texts matching the topic in this locale */
  synonyms?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Primary text for the topic in this locale */
  term: Scalars["String"]["input"];
};

export type TopicUnion =
  | Expertise
  | Locale
  | Location
  | Sector
  | Topic
  | UnknownTopic;

/** The connection type for TopicUnion. */
export type TopicUnionConnection = {
  __typename?: "TopicUnionConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TopicUnionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<TopicUnion>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

/** An edge in a connection. */
export type TopicUnionEdge = {
  __typename?: "TopicUnionEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge. */
  node?: Maybe<TopicUnion>;
};

export type UnknownTopic = NamedTopic &
  Node & {
    __typename?: "UnknownTopic";
    id: Scalars["ID"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
    slug?: Maybe<Scalars["String"]["output"]>;
  };

/** Autogenerated input type of UpdateTopicMutation */
export type UpdateTopicMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Timestamp at which the topic starts being promoted in the agency UX (in-app
   * prompts inviting agencies to add it to relevant services). Pass null to
   * un-feature the topic.
   */
  featuredAt?: InputMaybe<Scalars["ISO8601DateTime"]["input"]>;
  /** ID of the new parent topic. Pass null to detach from any parent. */
  parentTopicId?: InputMaybe<Scalars["ID"]["input"]>;
  /** ID of the topic to update. */
  topicId: Scalars["ID"]["input"];
  /** Translation entries (one per locale) to upsert on the topic. */
  translations?: InputMaybe<Array<TopicTranslationInput>>;
};

/** Autogenerated return type of UpdateTopicMutation. */
export type UpdateTopicMutationPayload = Node & {
  __typename?: "UpdateTopicMutationPayload";
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars["String"]["output"]>;
  /** ID of the object. */
  id: Scalars["ID"]["output"];
  topic: Topic;
};

export type Work = Node & {
  __typename?: "Work";
  agency: Agency;
  /** Service that was provided by the agency. */
  aspects: AspectConnection;
  budget?: Maybe<Scalars["Int"]["output"]>;
  challenges?: Maybe<Scalars["String"]["output"]>;
  company: Company;
  concretization?: Maybe<Scalars["Int"]["output"]>;
  createdAt: Scalars["ISO8601DateTime"]["output"];
  creativity?: Maybe<Scalars["Int"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  endDate?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  /** URLs of the illustrations that showcase the work. */
  illustrationUrls?: Maybe<Array<Scalars["String"]["output"]>>;
  impacts?: Maybe<Scalars["String"]["output"]>;
  link?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  position?: Maybe<Scalars["Int"]["output"]>;
  releasedAt?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  slug: Scalars["String"]["output"];
  solutions?: Maybe<Scalars["String"]["output"]>;
  specialization?: Maybe<Scalars["Int"]["output"]>;
  startDate?: Maybe<Scalars["ISO8601DateTime"]["output"]>;
  updatedAt: Scalars["ISO8601DateTime"]["output"];
  uuid: Scalars["String"]["output"];
};

export type WorkAspectsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The connection type for Work. */
export type WorkConnection = {
  __typename?: "WorkConnection";
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WorkEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Work>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

/** An edge in a connection. */
export type WorkEdge = {
  __typename?: "WorkEdge";
  /** A cursor for use in pagination. */
  cursor: Scalars["String"]["output"];
  /** The item at the end of the edge. */
  node?: Maybe<Work>;
};

/**
 * The sdl representing the federated service capabilities. Includes federation
 * directives, removes federation types, and includes rest of full schema after
 * schema directives have been applied
 */
export type _Service = {
  __typename?: "_Service";
  sdl?: Maybe<Scalars["String"]["output"]>;
};

export type AgencyMinQueryVariables = Exact<{
  slug: Scalars["String"]["input"];
}>;

export type AgencyMinQuery = {
  __typename?: "Query";
  agency: {
    __typename?: "Agency";
    name: string;
    logoUrl?: string | null;
    id: string;
  };
};

export type AgencyQueryVariables = Exact<{
  slug: Scalars["String"]["input"];
}>;

export type AgencyQuery = {
  __typename?: "Query";
  agency: {
    __typename?: "Agency";
    id: string;
    name: string;
    description?: string | null;
    coverPictureUrl?: string | null;
    logoUrl?: string | null;
    tagline?: string | null;
    updatedAt: any;
    foundedAt?: any | null;
    languages?: Array<string> | null;
    teamSize?: number | null;
    slug?: string | null;
    offices: {
      __typename?: "OfficeConnection";
      totalCount: number;
      nodes?: Array<{
        __typename?: "Office";
        id: string;
        address?: string | null;
        locality?: {
          __typename?: "Location";
          id: string;
          name?: string | null;
          slug?: string | null;
          country?: {
            __typename?: "Location";
            id: string;
            name?: string | null;
            iso31661?: string | null;
          } | null;
        } | null;
      } | null> | null;
    };
    awards: {
      __typename?: "AwardConnection";
      nodes?: Array<{
        __typename?: "Award";
        id: string;
        name: string;
      } | null> | null;
    };
    works: {
      __typename?: "WorkConnection";
      nodes?: Array<{
        __typename?: "Work";
        id: string;
        name?: string | null;
        slug: string;
        description?: string | null;
        solutions?: string | null;
        aspects: {
          __typename?: "AspectConnection";
          nodes?: Array<{
            __typename?: "Aspect";
            id: string;
            expertise?: {
              __typename?: "Expertise";
              id: string;
              name?: string | null;
            } | null;
          } | null> | null;
        };
        company: { __typename?: "Company"; id: string; name?: string | null };
      } | null> | null;
    };
    reviews: {
      __typename?: "ReviewConnection";
      averageRating?: number | null;
      totalCount: number;
      totalRating?: number | null;
      nodes?: Array<{
        __typename?: "Review";
        id: string;
        rating?: number | null;
        userFullName?: string | null;
        descriptionSummary?: string | null;
        service?: {
          __typename?: "Service";
          id: string;
          expertise: {
            __typename?: "Expertise";
            id: string;
            name?: string | null;
          };
        } | null;
      } | null> | null;
    };
    mainOffice?: {
      __typename?: "Office";
      id: string;
      address?: string | null;
      locality?: {
        __typename?: "Location";
        id: string;
        name?: string | null;
        slug?: string | null;
        geometry?: any | null;
        countryIso31661?: string | null;
        currency?: string | null;
        country?: {
          __typename?: "Location";
          id: string;
          name?: string | null;
        } | null;
      } | null;
    } | null;
    prospectAreas: {
      __typename?: "ProspectAreaConnection";
      nodes?: Array<{
        __typename?: "ProspectArea";
        id: string;
        address?: string | null;
      } | null> | null;
    };
    services: {
      __typename?: "ServiceConnection";
      nodes?: Array<{
        __typename?: "Service";
        id: string;
        description?: string | null;
        budget?: any[] | null;
        expertise: {
          __typename?: "Expertise";
          id: string;
          name?: string | null;
          category?: string | null;
        };
      } | null> | null;
    };
    socialProfiles?: {
      __typename?: "SocialProfiles";
      id: string;
      facebook?: string | null;
      instagram?: string | null;
      linkedin?: string | null;
      pinterest?: string | null;
      vimeo?: string | null;
      x?: string | null;
      youtube?: string | null;
    } | null;
  };
};

export type AgencyFragmentFragment = {
  __typename?: "Agency";
  id: string;
  slug?: string | null;
  foundedAt?: any | null;
  tagline?: string | null;
  prospectAreas: {
    __typename?: "ProspectAreaConnection";
    nodes?: Array<{
      __typename?: "ProspectArea";
      id: string;
      address?: string | null;
    } | null> | null;
  };
  services: {
    __typename?: "ServiceConnection";
    nodes?: Array<{
      __typename?: "Service";
      id: string;
      description?: string | null;
      budget?: any[] | null;
      expertise: {
        __typename?: "Expertise";
        id: string;
        name?: string | null;
        category?: string | null;
      };
    } | null> | null;
  };
  socialProfiles?: {
    __typename?: "SocialProfiles";
    id: string;
    facebook?: string | null;
    instagram?: string | null;
    linkedin?: string | null;
    pinterest?: string | null;
    vimeo?: string | null;
    x?: string | null;
    youtube?: string | null;
  } | null;
  mainOffice?: {
    __typename?: "Office";
    id: string;
    address?: string | null;
    locality?: {
      __typename?: "Location";
      id: string;
      geometry?: any | null;
      name?: string | null;
      countryIso31661?: string | null;
      currency?: string | null;
    } | null;
  } | null;
  reviews: {
    __typename?: "ReviewConnection";
    averageRating?: number | null;
    totalCount: number;
    totalRating?: number | null;
    nodes?: Array<{
      __typename?: "Review";
      id: string;
      rating?: number | null;
    } | null> | null;
  };
};

export type PageQueryVariables = Exact<{
  host: Scalars["String"]["input"];
  locale: Scalars["String"]["input"];
  path: Scalars["String"]["input"];
  lastOrganic?: InputMaybe<Scalars["Int"]["input"]>;
  firstOrganic?: InputMaybe<Scalars["Int"]["input"]>;
  firstPaid?: InputMaybe<Scalars["Int"]["input"]>;
  lastPaid?: InputMaybe<Scalars["Int"]["input"]>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type PageQuery = {
  __typename?: "Query";
  page: {
    __typename?: "Page";
    id: string;
    updatedAt: any;
    organicAgencies: {
      __typename?: "PagesAgencyConnection";
      nodes?: Array<{
        __typename?: "PagesAgency";
        id: string;
        agency: {
          __typename?: "Agency";
          id: string;
          slug?: string | null;
          foundedAt?: any | null;
          tagline?: string | null;
          prospectAreas: {
            __typename?: "ProspectAreaConnection";
            nodes?: Array<{
              __typename?: "ProspectArea";
              id: string;
              address?: string | null;
            } | null> | null;
          };
          services: {
            __typename?: "ServiceConnection";
            nodes?: Array<{
              __typename?: "Service";
              id: string;
              description?: string | null;
              budget?: any[] | null;
              expertise: {
                __typename?: "Expertise";
                id: string;
                name?: string | null;
                category?: string | null;
              };
            } | null> | null;
          };
          socialProfiles?: {
            __typename?: "SocialProfiles";
            id: string;
            facebook?: string | null;
            instagram?: string | null;
            linkedin?: string | null;
            pinterest?: string | null;
            vimeo?: string | null;
            x?: string | null;
            youtube?: string | null;
          } | null;
          mainOffice?: {
            __typename?: "Office";
            id: string;
            address?: string | null;
            locality?: {
              __typename?: "Location";
              id: string;
              geometry?: any | null;
              name?: string | null;
              countryIso31661?: string | null;
              currency?: string | null;
            } | null;
          } | null;
          reviews: {
            __typename?: "ReviewConnection";
            averageRating?: number | null;
            totalCount: number;
            totalRating?: number | null;
            nodes?: Array<{
              __typename?: "Review";
              id: string;
              rating?: number | null;
            } | null> | null;
          };
        };
      } | null> | null;
    };
    paidAgencies: {
      __typename?: "PagesAgencyConnection";
      nodes?: Array<{
        __typename?: "PagesAgency";
        id: string;
        agency: {
          __typename?: "Agency";
          id: string;
          slug?: string | null;
          foundedAt?: any | null;
          tagline?: string | null;
          prospectAreas: {
            __typename?: "ProspectAreaConnection";
            nodes?: Array<{
              __typename?: "ProspectArea";
              id: string;
              address?: string | null;
            } | null> | null;
          };
          services: {
            __typename?: "ServiceConnection";
            nodes?: Array<{
              __typename?: "Service";
              id: string;
              description?: string | null;
              budget?: any[] | null;
              expertise: {
                __typename?: "Expertise";
                id: string;
                name?: string | null;
                category?: string | null;
              };
            } | null> | null;
          };
          socialProfiles?: {
            __typename?: "SocialProfiles";
            id: string;
            facebook?: string | null;
            instagram?: string | null;
            linkedin?: string | null;
            pinterest?: string | null;
            vimeo?: string | null;
            x?: string | null;
            youtube?: string | null;
          } | null;
          mainOffice?: {
            __typename?: "Office";
            id: string;
            address?: string | null;
            locality?: {
              __typename?: "Location";
              id: string;
              geometry?: any | null;
              name?: string | null;
              countryIso31661?: string | null;
              currency?: string | null;
            } | null;
          } | null;
          reviews: {
            __typename?: "ReviewConnection";
            averageRating?: number | null;
            totalCount: number;
            totalRating?: number | null;
            nodes?: Array<{
              __typename?: "Review";
              id: string;
              rating?: number | null;
            } | null> | null;
          };
        };
      } | null> | null;
    };
  };
};

export type GetWorkQueryVariables = Exact<{
  slug: Scalars["String"]["input"];
}>;

export type GetWorkQuery = {
  __typename?: "Query";
  work: {
    __typename?: "Work";
    id: string;
    slug: string;
    name?: string | null;
    description?: string | null;
    position?: number | null;
    startDate?: any | null;
    endDate?: any | null;
    illustrationUrls?: Array<string> | null;
    challenges?: string | null;
    solutions?: string | null;
    impacts?: string | null;
    link?: string | null;
    budget?: number | null;
    company: {
      __typename?: "Company";
      id: string;
      name?: string | null;
      address?: string | null;
      marketType?: string | null;
      marketSize?: string | null;
      sector?: {
        __typename?: "Sector";
        id: string;
        name?: string | null;
      } | null;
    };
    agency: {
      __typename?: "Agency";
      id: string;
      name: string;
      slug?: string | null;
      logoUrl?: string | null;
    };
    aspects: {
      __typename?: "AspectConnection";
      nodes?: Array<{
        __typename?: "Aspect";
        id: string;
        expertise?: {
          __typename?: "Expertise";
          id: string;
          name?: string | null;
        } | null;
      } | null> | null;
    };
  };
};

export type GetAgencyAwardsQueryVariables = Exact<{
  slug: Scalars["String"]["input"];
  first: Scalars["Int"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetAgencyAwardsQuery = {
  __typename?: "Query";
  agency: {
    __typename?: "Agency";
    id: string;
    awards: {
      __typename?: "AwardConnection";
      totalCount: number;
      pageInfo: {
        __typename?: "PageInfo";
        endCursor?: string | null;
        hasNextPage: boolean;
      };
      nodes?: Array<{
        __typename?: "Award";
        id: string;
        name: string;
        category?: string | null;
        wonAt?: any | null;
        work?: { __typename?: "Work"; id: string; slug: string } | null;
      } | null> | null;
    };
  };
};

export type GetAgencyProfileQueryVariables = Exact<{
  slug: Scalars["String"]["input"];
}>;

export type GetAgencyProfileQuery = {
  __typename?: "Query";
  agency: {
    __typename?: "Agency";
    id: string;
    uuid: string;
    slug?: string | null;
    name: string;
    description?: string | null;
    tagline?: string | null;
    story?: string | null;
    logoUrl?: string | null;
    coverPictureUrl?: string | null;
    teamPictureUrl?: string | null;
    locale?: string | null;
    languages?: Array<string> | null;
    remotely?: boolean | null;
    live: boolean;
    foundedAt?: any | null;
    teamSize?: number | null;
    claimed?: boolean | null;
    trustedPartner?: boolean | null;
    paidMember?: boolean | null;
    website?: string | null;
    turnover?: any | null;
    wonOpportunitiesCount: number;
    createdAt: any;
    aiReviewSummary?: {
      __typename?: "AiReviewSummary";
      keyPoints?: Array<string> | null;
      themes?: Array<{
        __typename?: "AiReviewSummaryTheme";
        title: string;
        description: string;
      }> | null;
    } | null;
    mainOffice?: {
      __typename?: "Office";
      id: string;
      address?: string | null;
      locality?: {
        __typename?: "Location";
        id: string;
        name?: string | null;
        googlePlaceId?: string | null;
        country?: {
          __typename?: "Location";
          id: string;
          name?: string | null;
          iso31661?: string | null;
        } | null;
      } | null;
    } | null;
    socialProfiles?: {
      __typename?: "SocialProfiles";
      id: string;
      linkedin?: string | null;
      facebook?: string | null;
      x?: string | null;
      instagram?: string | null;
      youtube?: string | null;
      vimeo?: string | null;
      pinterest?: string | null;
    } | null;
    reviews: {
      __typename?: "ReviewConnection";
      totalCount: number;
      averageRating?: number | null;
    };
    works: { __typename?: "WorkConnection"; totalCount: number };
    awards: { __typename?: "AwardConnection"; totalCount: number };
    offices: {
      __typename?: "OfficeConnection";
      totalCount: number;
      nodes?: Array<{
        __typename?: "Office";
        id: string;
        address?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        position?: number | null;
        locality?: {
          __typename?: "Location";
          id: string;
          name?: string | null;
          slug?: string | null;
          country?: {
            __typename?: "Location";
            id: string;
            name?: string | null;
            slug?: string | null;
            iso31661?: string | null;
          } | null;
        } | null;
      } | null> | null;
    };
    services: {
      __typename?: "ServiceConnection";
      totalCount: number;
      nodes?: Array<{
        __typename?: "Service";
        id: string;
        description?: string | null;
        budget?: any[] | null;
        position?: number | null;
        expertise: {
          __typename?: "Expertise";
          id: string;
          name?: string | null;
          slug?: string | null;
          uuid: string;
        };
        reviews: {
          __typename?: "ReviewConnection";
          totalCount: number;
          averageRating?: number | null;
          nodes?: Array<{
            __typename?: "Review";
            id: string;
            userFullName?: string | null;
            rating?: number | null;
          } | null> | null;
        };
        works: {
          __typename?: "WorkConnection";
          totalCount: number;
          nodes?: Array<{
            __typename?: "Work";
            id: string;
            name?: string | null;
            slug: string;
            position?: number | null;
            illustrationUrls?: Array<string> | null;
            company: {
              __typename?: "Company";
              id: string;
              name?: string | null;
              marketType?: string | null;
              marketSize?: string | null;
              sector?: {
                __typename?: "Sector";
                id: string;
                name?: string | null;
              } | null;
            };
          } | null> | null;
        };
        skills: {
          __typename?: "TopicConnection";
          totalCount: number;
          nodes?: Array<{
            __typename?: "Topic";
            id: string;
            name?: string | null;
            slug?: string | null;
          } | null> | null;
        };
      } | null> | null;
    };
  };
};

export type GetAgencyReviewsQueryVariables = Exact<{
  slug: Scalars["String"]["input"];
  first: Scalars["Int"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetAgencyReviewsQuery = {
  __typename?: "Query";
  agency: {
    __typename?: "Agency";
    id: string;
    reviews: {
      __typename?: "ReviewConnection";
      totalCount: number;
      averageRating?: number | null;
      pageInfo: {
        __typename?: "PageInfo";
        endCursor?: string | null;
        hasNextPage: boolean;
      };
      nodes?: Array<{
        __typename?: "Review";
        id: string;
        slug: string;
        rating?: number | null;
        userFullName?: string | null;
        userCompanyName?: string | null;
        userPictureUrl?: string | null;
        userJobTitle?: string | null;
        ratingBudget?: number | null;
        ratingCollaboration?: number | null;
        ratingQuality?: number | null;
        ratingSchedule?: number | null;
        descriptionSummary?: string | null;
        descriptionCons?: string | null;
        descriptionPros?: string | null;
        recommended?: boolean | null;
        reply?: string | null;
        companySize?: any[] | null;
        verifiedAt?: any | null;
        updatedAt: any;
        createdAt: any;
        sector?: {
          __typename?: "Sector";
          id: string;
          name?: string | null;
        } | null;
        service?: {
          __typename?: "Service";
          id: string;
          expertise: {
            __typename?: "Expertise";
            id: string;
            name?: string | null;
          };
        } | null;
      } | null> | null;
    };
  };
};

export type GetAgencyWorksQueryVariables = Exact<{
  slug: Scalars["String"]["input"];
  first: Scalars["Int"]["input"];
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetAgencyWorksQuery = {
  __typename?: "Query";
  agency: {
    __typename?: "Agency";
    id: string;
    works: {
      __typename?: "WorkConnection";
      totalCount: number;
      pageInfo: {
        __typename?: "PageInfo";
        endCursor?: string | null;
        hasNextPage: boolean;
      };
      nodes?: Array<{
        __typename?: "Work";
        id: string;
        slug: string;
        name?: string | null;
        description?: string | null;
        position?: number | null;
        startDate?: any | null;
        endDate?: any | null;
        illustrationUrls?: Array<string> | null;
        company: {
          __typename?: "Company";
          id: string;
          name?: string | null;
          marketType?: string | null;
          marketSize?: string | null;
          sector?: {
            __typename?: "Sector";
            id: string;
            name?: string | null;
          } | null;
        };
        aspects: {
          __typename?: "AspectConnection";
          nodes?: Array<{
            __typename?: "Aspect";
            id: string;
            expertise?: {
              __typename?: "Expertise";
              id: string;
              name?: string | null;
            } | null;
          } | null> | null;
        };
      } | null> | null;
    };
  };
};

export type AgencyCardDataFragment = {
  __typename?: "Agency";
  id: string;
  slug?: string | null;
  name: string;
  logoUrl?: string | null;
  claimed?: boolean | null;
  paidMember?: boolean | null;
  trustedPartner?: boolean | null;
  externalId?: string | null;
  uuid: string;
  services: {
    __typename?: "ServiceConnection";
    totalCount: number;
    nodes?: Array<{
      __typename?: "Service";
      id: string;
      expertise: { __typename?: "Expertise"; name?: string | null };
    } | null> | null;
  };
  awards: { __typename?: "AwardConnection"; totalCount: number };
  reviews: {
    __typename?: "ReviewConnection";
    averageRating?: number | null;
    totalCount: number;
    nodes?: Array<{
      __typename?: "Review";
      id: string;
      recommended?: boolean | null;
      createdAt: any;
      isRecentlyRecommended: boolean;
    } | null> | null;
  };
};

export type SimilarAgenciesQueryVariables = Exact<{
  agencySlug: Scalars["String"]["input"];
}>;

export type SimilarAgenciesQuery = {
  __typename?: "Query";
  agency: {
    __typename?: "Agency";
    id: string;
    competitors?: {
      __typename?: "AgencyConnection";
      nodes?: Array<{
        __typename?: "Agency";
        id: string;
        slug?: string | null;
        name: string;
        logoUrl?: string | null;
        claimed?: boolean | null;
        paidMember?: boolean | null;
        trustedPartner?: boolean | null;
        externalId?: string | null;
        uuid: string;
        services: {
          __typename?: "ServiceConnection";
          totalCount: number;
          nodes?: Array<{
            __typename?: "Service";
            id: string;
            expertise: { __typename?: "Expertise"; name?: string | null };
          } | null> | null;
        };
        awards: { __typename?: "AwardConnection"; totalCount: number };
        reviews: {
          __typename?: "ReviewConnection";
          averageRating?: number | null;
          totalCount: number;
          nodes?: Array<{
            __typename?: "Review";
            id: string;
            recommended?: boolean | null;
            createdAt: any;
            isRecentlyRecommended: boolean;
          } | null> | null;
        };
      } | null> | null;
    } | null;
  };
};

export type TopPaidAgenciesQueryVariables = Exact<{
  host: Scalars["String"]["input"];
  locale: Scalars["String"]["input"];
  path: Scalars["String"]["input"];
}>;

export type TopPaidAgenciesQuery = {
  __typename?: "Query";
  paidAgencies: {
    __typename?: "Page";
    pagesAgencies: {
      __typename?: "PagesAgencyConnection";
      nodes?: Array<{
        __typename?: "PagesAgency";
        section: PagesAgencySection;
        agency: {
          __typename?: "Agency";
          id: string;
          slug?: string | null;
          name: string;
          logoUrl?: string | null;
          claimed?: boolean | null;
          paidMember?: boolean | null;
          trustedPartner?: boolean | null;
          externalId?: string | null;
          uuid: string;
          services: {
            __typename?: "ServiceConnection";
            totalCount: number;
            nodes?: Array<{
              __typename?: "Service";
              id: string;
              expertise: { __typename?: "Expertise"; name?: string | null };
            } | null> | null;
          };
          awards: { __typename?: "AwardConnection"; totalCount: number };
          reviews: {
            __typename?: "ReviewConnection";
            averageRating?: number | null;
            totalCount: number;
            nodes?: Array<{
              __typename?: "Review";
              id: string;
              recommended?: boolean | null;
              createdAt: any;
              isRecentlyRecommended: boolean;
            } | null> | null;
          };
        };
      } | null> | null;
    };
  };
  organicAgencies: {
    __typename?: "Page";
    pagesAgencies: {
      __typename?: "PagesAgencyConnection";
      nodes?: Array<{
        __typename?: "PagesAgency";
        section: PagesAgencySection;
        agency: {
          __typename?: "Agency";
          id: string;
          slug?: string | null;
          name: string;
          logoUrl?: string | null;
          claimed?: boolean | null;
          paidMember?: boolean | null;
          trustedPartner?: boolean | null;
          externalId?: string | null;
          uuid: string;
          services: {
            __typename?: "ServiceConnection";
            totalCount: number;
            nodes?: Array<{
              __typename?: "Service";
              id: string;
              expertise: { __typename?: "Expertise"; name?: string | null };
            } | null> | null;
          };
          awards: { __typename?: "AwardConnection"; totalCount: number };
          reviews: {
            __typename?: "ReviewConnection";
            averageRating?: number | null;
            totalCount: number;
            nodes?: Array<{
              __typename?: "Review";
              id: string;
              recommended?: boolean | null;
              createdAt: any;
              isRecentlyRecommended: boolean;
            } | null> | null;
          };
        };
      } | null> | null;
    };
  };
};

export const AgencyFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AgencyFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Agency" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "foundedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "prospectAreas" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "services" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "budget" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "expertise" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "category" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "tagline" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "socialProfiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "facebook" } },
                { kind: "Field", name: { kind: "Name", value: "instagram" } },
                { kind: "Field", name: { kind: "Name", value: "linkedin" } },
                { kind: "Field", name: { kind: "Name", value: "pinterest" } },
                { kind: "Field", name: { kind: "Name", value: "vimeo" } },
                { kind: "Field", name: { kind: "Name", value: "x" } },
                { kind: "Field", name: { kind: "Name", value: "youtube" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "mainOffice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "address" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "locality" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "geometry" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "countryIso31661" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currency" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reviews" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "IntValue", value: "50" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "averageRating" },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                { kind: "Field", name: { kind: "Name", value: "totalRating" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rating" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AgencyFragmentFragment, unknown>;
export const AgencyCardDataFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AgencyCardData" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Agency" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "logoUrl" } },
          { kind: "Field", name: { kind: "Name", value: "claimed" } },
          { kind: "Field", name: { kind: "Name", value: "paidMember" } },
          { kind: "Field", name: { kind: "Name", value: "trustedPartner" } },
          { kind: "Field", name: { kind: "Name", value: "externalId" } },
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "services" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "IntValue", value: "3" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "expertise" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "awards" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reviews" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "IntValue", value: "30" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "averageRating" },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "recommended" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isRecentlyRecommended" },
                        directives: [
                          {
                            kind: "Directive",
                            name: { kind: "Name", value: "client" },
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AgencyCardDataFragment, unknown>;
export const AgencyMinDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AgencyMin" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "agency" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "slug" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "slug" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "logoUrl" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AgencyMinQuery, AgencyMinQueryVariables>;
export const AgencyDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Agency" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "agency" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "slug" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "slug" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "AgencyFragment" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coverPictureUrl" },
                },
                { kind: "Field", name: { kind: "Name", value: "logoUrl" } },
                { kind: "Field", name: { kind: "Name", value: "tagline" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "foundedAt" } },
                { kind: "Field", name: { kind: "Name", value: "languages" } },
                { kind: "Field", name: { kind: "Name", value: "teamSize" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offices" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalCount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nodes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "locality" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "slug" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "country" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "iso31661",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "awards" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nodes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "works" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nodes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "solutions" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "aspects" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "nodes" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "expertise",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "name",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "company" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reviews" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "IntValue", value: "50" },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nodes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rating" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "userFullName" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "descriptionSummary",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "service" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "expertise" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mainOffice" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "locality" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "country" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AgencyFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Agency" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "foundedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "prospectAreas" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "services" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "budget" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "expertise" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "category" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "tagline" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "socialProfiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "facebook" } },
                { kind: "Field", name: { kind: "Name", value: "instagram" } },
                { kind: "Field", name: { kind: "Name", value: "linkedin" } },
                { kind: "Field", name: { kind: "Name", value: "pinterest" } },
                { kind: "Field", name: { kind: "Name", value: "vimeo" } },
                { kind: "Field", name: { kind: "Name", value: "x" } },
                { kind: "Field", name: { kind: "Name", value: "youtube" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "mainOffice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "address" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "locality" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "geometry" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "countryIso31661" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currency" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reviews" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "IntValue", value: "50" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "averageRating" },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                { kind: "Field", name: { kind: "Name", value: "totalRating" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rating" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AgencyQuery, AgencyQueryVariables>;
export const PageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Page" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "host" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "path" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "lastOrganic" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "firstOrganic" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "firstPaid" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "lastPaid" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "after" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "before" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "page" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "host" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "host" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "path" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "path" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "organicAgencies" },
                  name: { kind: "Name", value: "pagesAgencies" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "firstOrganic" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "last" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "lastOrganic" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "before" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "before" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "after" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "after" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "filter" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "sections" },
                            value: {
                              kind: "ListValue",
                              values: [{ kind: "EnumValue", value: "ORGANIC" }],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nodes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "agency" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "AgencyFragment",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  alias: { kind: "Name", value: "paidAgencies" },
                  name: { kind: "Name", value: "pagesAgencies" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "firstPaid" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "last" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "lastPaid" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "before" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "before" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "after" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "after" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "filter" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "sections" },
                            value: {
                              kind: "ListValue",
                              values: [{ kind: "EnumValue", value: "PAID" }],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nodes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "agency" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "AgencyFragment",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AgencyFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Agency" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "foundedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "prospectAreas" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "services" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "budget" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "expertise" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "category" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "tagline" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "socialProfiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "facebook" } },
                { kind: "Field", name: { kind: "Name", value: "instagram" } },
                { kind: "Field", name: { kind: "Name", value: "linkedin" } },
                { kind: "Field", name: { kind: "Name", value: "pinterest" } },
                { kind: "Field", name: { kind: "Name", value: "vimeo" } },
                { kind: "Field", name: { kind: "Name", value: "x" } },
                { kind: "Field", name: { kind: "Name", value: "youtube" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "mainOffice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "address" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "locality" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "geometry" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "countryIso31661" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currency" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reviews" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "IntValue", value: "50" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "averageRating" },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                { kind: "Field", name: { kind: "Name", value: "totalRating" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rating" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PageQuery, PageQueryVariables>;
export const GetWorkDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetWork" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "work" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "slug" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "slug" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "position" } },
                { kind: "Field", name: { kind: "Name", value: "startDate" } },
                { kind: "Field", name: { kind: "Name", value: "endDate" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "illustrationUrls" },
                },
                { kind: "Field", name: { kind: "Name", value: "challenges" } },
                { kind: "Field", name: { kind: "Name", value: "solutions" } },
                { kind: "Field", name: { kind: "Name", value: "impacts" } },
                { kind: "Field", name: { kind: "Name", value: "link" } },
                { kind: "Field", name: { kind: "Name", value: "budget" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "company" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "marketType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "marketSize" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sector" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "agency" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "slug" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "logoUrl" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aspects" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "IntValue", value: "5" },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nodes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "expertise" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetWorkQuery, GetWorkQueryVariables>;
export const GetAgencyAwardsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAgencyAwards" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "first" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "after" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "agency" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "slug" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "slug" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "awards" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "first" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "after" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "after" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalCount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "endCursor" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hasNextPage" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nodes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "category" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "wonAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "work" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "slug" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAgencyAwardsQuery,
  GetAgencyAwardsQueryVariables
>;
export const GetAgencyProfileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAgencyProfile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "agency" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "slug" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "slug" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                { kind: "Field", name: { kind: "Name", value: "slug" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "tagline" } },
                { kind: "Field", name: { kind: "Name", value: "story" } },
                { kind: "Field", name: { kind: "Name", value: "logoUrl" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coverPictureUrl" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "teamPictureUrl" },
                },
                { kind: "Field", name: { kind: "Name", value: "locale" } },
                { kind: "Field", name: { kind: "Name", value: "languages" } },
                { kind: "Field", name: { kind: "Name", value: "remotely" } },
                { kind: "Field", name: { kind: "Name", value: "live" } },
                { kind: "Field", name: { kind: "Name", value: "foundedAt" } },
                { kind: "Field", name: { kind: "Name", value: "teamSize" } },
                { kind: "Field", name: { kind: "Name", value: "claimed" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "trustedPartner" },
                },
                { kind: "Field", name: { kind: "Name", value: "paidMember" } },
                { kind: "Field", name: { kind: "Name", value: "website" } },
                { kind: "Field", name: { kind: "Name", value: "turnover" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "wonOpportunitiesCount" },
                },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aiReviewSummary" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "keyPoints" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "themes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mainOffice" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "address" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "locality" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "googlePlaceId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "country" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "iso31661" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "socialProfiles" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "linkedin" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "facebook" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "x" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "instagram" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "youtube" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "vimeo" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pinterest" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reviews" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "IntValue", value: "0" },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalCount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "averageRating" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "works" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "IntValue", value: "0" },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalCount" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "awards" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "IntValue", value: "0" },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalCount" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "offices" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalCount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nodes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "address" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "latitude" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "longitude" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "position" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "locality" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "slug" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "country" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "slug" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "iso31661",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "services" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "IntValue", value: "40" },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalCount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nodes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "budget" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "position" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "expertise" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "slug" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "uuid" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reviews" },
                              arguments: [
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "first" },
                                  value: { kind: "IntValue", value: "4" },
                                },
                              ],
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "totalCount" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "averageRating",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "nodes" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "userFullName",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "rating",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "works" },
                              arguments: [
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "first" },
                                  value: { kind: "IntValue", value: "4" },
                                },
                              ],
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "totalCount" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "nodes" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "slug" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "position",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "illustrationUrls",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "company",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "name",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "sector",
                                                },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "id",
                                                      },
                                                    },
                                                    {
                                                      kind: "Field",
                                                      name: {
                                                        kind: "Name",
                                                        value: "name",
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "marketType",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "marketSize",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "skills" },
                              arguments: [
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "first" },
                                  value: { kind: "IntValue", value: "30" },
                                },
                              ],
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "totalCount" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "nodes" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "slug" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAgencyProfileQuery,
  GetAgencyProfileQueryVariables
>;
export const GetAgencyReviewsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAgencyReviews" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "first" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "after" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "agency" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "slug" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "slug" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reviews" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "first" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "after" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "after" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalCount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "averageRating" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "endCursor" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hasNextPage" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nodes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rating" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "userFullName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "userCompanyName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "userPictureUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "userJobTitle" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ratingBudget" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "ratingCollaboration",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ratingQuality" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ratingSchedule" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "descriptionSummary",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "descriptionCons" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "descriptionPros" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "recommended" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reply" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "companySize" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sector" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "service" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "expertise" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "verifiedAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "updatedAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "createdAt" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAgencyReviewsQuery,
  GetAgencyReviewsQueryVariables
>;
export const GetAgencyWorksDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAgencyWorks" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "slug" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "first" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "after" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "agency" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "slug" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "slug" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "works" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "first" },
                      },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "after" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "after" },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalCount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "endCursor" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hasNextPage" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nodes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "slug" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "position" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "startDate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "endDate" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "illustrationUrls" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "company" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "marketType" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "marketSize" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sector" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "aspects" },
                              arguments: [
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "first" },
                                  value: { kind: "IntValue", value: "5" },
                                },
                              ],
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "nodes" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "expertise",
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "id",
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "name",
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAgencyWorksQuery, GetAgencyWorksQueryVariables>;
export const SimilarAgenciesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SimilarAgencies" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "agencySlug" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "agency" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "slug" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "agencySlug" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "competitors" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "IntValue", value: "3" },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nodes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "AgencyCardData" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AgencyCardData" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Agency" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "logoUrl" } },
          { kind: "Field", name: { kind: "Name", value: "claimed" } },
          { kind: "Field", name: { kind: "Name", value: "paidMember" } },
          { kind: "Field", name: { kind: "Name", value: "trustedPartner" } },
          { kind: "Field", name: { kind: "Name", value: "externalId" } },
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "services" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "IntValue", value: "3" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "expertise" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "awards" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reviews" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "IntValue", value: "30" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "averageRating" },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "recommended" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isRecentlyRecommended" },
                        directives: [
                          {
                            kind: "Directive",
                            name: { kind: "Name", value: "client" },
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SimilarAgenciesQuery,
  SimilarAgenciesQueryVariables
>;
export const TopPaidAgenciesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "TopPaidAgencies" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "host" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locale" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "path" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "paidAgencies" },
            name: { kind: "Name", value: "page" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "host" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "host" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "path" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "path" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pagesAgencies" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "IntValue", value: "3" },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "filter" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "sections" },
                            value: {
                              kind: "ListValue",
                              values: [{ kind: "EnumValue", value: "PAID" }],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nodes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "section" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "agency" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "AgencyCardData",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "organicAgencies" },
            name: { kind: "Name", value: "page" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "host" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "host" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "locale" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locale" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "path" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "path" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pagesAgencies" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "IntValue", value: "3" },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "filter" },
                      value: {
                        kind: "ObjectValue",
                        fields: [
                          {
                            kind: "ObjectField",
                            name: { kind: "Name", value: "sections" },
                            value: {
                              kind: "ListValue",
                              values: [{ kind: "EnumValue", value: "ORGANIC" }],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nodes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "section" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "agency" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "AgencyCardData",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AgencyCardData" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Agency" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "logoUrl" } },
          { kind: "Field", name: { kind: "Name", value: "claimed" } },
          { kind: "Field", name: { kind: "Name", value: "paidMember" } },
          { kind: "Field", name: { kind: "Name", value: "trustedPartner" } },
          { kind: "Field", name: { kind: "Name", value: "externalId" } },
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "services" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "IntValue", value: "3" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "expertise" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "awards" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "reviews" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "IntValue", value: "30" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "averageRating" },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "recommended" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isRecentlyRecommended" },
                        directives: [
                          {
                            kind: "Directive",
                            name: { kind: "Name", value: "client" },
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TopPaidAgenciesQuery,
  TopPaidAgenciesQueryVariables
>;
